const envConfig = {
  "stage": "dev",
  "appName": "account-registration-web",
  "appNameSuffix": "-main"
};
export default envConfig;